module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "not-found__message text-xs-center"
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("PÁGINA NO ENCONTRADA")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")]), _vm._v(" Volver atrás")], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("4")]), _vm._v("0"), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("4")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4d0b28a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/pages/AppNotFound.vue
// module id = 536
// module chunks = 2